import {
    $fontWeightBold,
    $fontWeightBolder,
    $fontWeightLight,
    styled,
} from '@acko-tech/building-blocks.ui.common';
// import {styled} from '@acko-tech/building-blocks.ui.common';

const spacing = '16px';

export const PageWrapper = styled.div`
    margin: 30px 0;
`;

export const Wrapper = styled.div`
    border-radius: 8px;
    border: 1px solid #e0e0e7;
`;

export const HeaderContainer = styled.div`
    padding: ${spacing};
    border-bottom: 1px solid #e0e0e7;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Heading = styled.p`
    margin: 0;
    font-weight: ${$fontWeightBolder};
    display: flex;
    align-items: center;
    color: #040222;
`;

export const PageHeading = styled.div`
    font-size: 18px;
    margin-bottom: 25px;
    font-weight: ${$fontWeightBolder};
`;

export const Link = styled.div`
    color: #1a73e7;
    cursor: pointer;
`;

export const BodyContainer = styled.div`
    padding: ${spacing} ${spacing} 0 ${spacing};
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${spacing};
`;

export const Label = styled.div`
    color: #040222;
    font-weight: ${$fontWeightBold};
    width: max-content;
`;

export const Value = styled.div`
    color: gray;
    font-weight: ${$fontWeightLight};
    width: max-content;
    text-align: right;
    overflow-wrap: break-word;
    word-wrap: break-word;
    hyphens: auto;
`;

export const ImageContainer = styled.div`
    display: flex;
    margin-right: 10px;
`;
